import React from 'react';

import Integrated from './Integrated';

function App() {
  return (
    <div className="App">
      <Integrated/>
    </div>
  );
}

export default App;